<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Food Products</h3>
      </div>
      <div class="content-header-right col-md-8 col-12">
        <div class="breadcrumbs-top">
          <div class="breadcrumb-wrapper mr-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
              <li class="breadcrumb-item"><router-link to="/calendar">{{this.$route.params.date}}</router-link></li>
              <li class="breadcrumb-item"><router-link v-bind:to="'/preorder/' + this.$route.params.date">Pre-Order</router-link></li>
              <li class="breadcrumb-item"><router-link v-bind:to="'/preorder/' + this.$route.params.date + '/' + $route.params.period">Categories</router-link></li>
              <li class="breadcrumb-item"><router-link v-bind:to="'/preorder/' + this.$route.params.date + '/' + $route.params.period + '/' + $route.params.category">{{$route.params.category}}</router-link></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-content products">
              <div class="card-body">
                <div class="media d-flex" v-if="useWallet()">
                  <div class="align-self-top">
                    <i class="icon-wallet icon-opacity font-large-4 float-left"></i>
                  </div>
                  <div class="media-body text-right align-self-bottom">
                    <span class="d-block mb-1 font-medium-1">Wallet Balance</span>
                    <h1 class="mb-0">R{{balance}}</h1><br />

                  </div>

                </div>
                <button type="button" class="btn btn-danger btn-block" v-on:click="checkout">Checkout ({{cart.length}} Items)</button>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-content products">

              <div class="card-collapse">
                <div class="card mb-0">
                  <div class="card" v-for="category in categories" v-bind:key="category.id" v-if="category.title">

                    <div class="card-header">
                      <h5 class="mb-0">
                        <button class="btn btn-link" data-toggle="collapse" :data-target="'#collapse-' + category.id"  aria-expanded="true">
                          {{category.title}}
                        </button>
                      </h5>
                    </div>

                    <div v-bind:id="'collapse-' + category.id" class="collapse show">
                      <div class="card-body">
                        <table class="table-striped">
                          <tbody v-for="item in items" v-bind:key="item.id" v-if="item.meal_category_id == category.id">
                            <tr>
                              <td>{{item.label}}</td>
                              <td>R{{item.price}}</td>
                              <td><button type="button" class="btn btn-primary" v-on:click="showModificationsModal(item)">Add</button></td>
                            </tr>
                            <tr v-if="item.description">
                              <td colspan="3"><small>{{item.description}}</small></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="modifications-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Customize Order</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-horizontal additions-exclusions-form">
              <fieldset class="form-group" v-if="inclusions && inclusions.length > 0">
                <h5>Any additions?</h5>

                <div class="card-accordion">
                  <div class="card collapse-icon accordion-icon-rotate right" v-for="(inclusion, index) in inclusions" v-bind:key="inclusion.id">
                    <div class="card">
                      <div class="card-header">
                        <h5 class="mb-0">
                          <button class="btn btn-link" data-toggle="collapse" v-bind:data-target="'#collapse-addition-' + index" aria-expanded="true">
                            {{inclusion.addition_type}}
                          </button>
                        </h5>
                      </div>

                      <div v-bind:id="'collapse-addition-' + index" class="collapse inclusions-card show">
                        <div class="card-body" v-if="inclusion.addition_input_type == 'single'">
                          <p>Select One:</p>

                          <button v-bind:id="'custom-block-' + addition.id" v-for="addition in inclusion.additions" v-bind:key="addition.id" type="button" class="mb-1 btn btn-outline-secondary btn-block single-block custom-block">{{addition.label}} - R{{addition.price}}</button>
                        </div>
                        <div class="card-body" v-if="inclusion.addition_input_type == 'multi'">
                          <p>Select Multiple:</p>

                          <button v-bind:id="'custom-block-' + addition.id" v-for="addition in inclusion.additions" v-bind:key="addition.id" type="button" class="mb-1 btn btn-outline-secondary btn-block multiple-block custom-block">{{addition.label}} - R{{addition.price}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </fieldset>

              <fieldset class="form-group" v-if="exclusions && exclusions.length > 0">
                <h5>Any exclusions?</h5>

                <div class="card-accordion">
                  <div class="card collapse-icon accordion-icon-rotate right" v-for="(exclusion, index) in exclusions" v-bind:key="exclusion.id">
                    <div class="card">
                      <div class="card-header">
                        <h5 class="mb-0">
                          <button class="btn btn-link" data-toggle="collapse" v-bind:data-target="'#collapse-exclusion-' + index" aria-expanded="false">
                            {{exclusion.exclusion_type}}
                          </button>
                        </h5>
                      </div>

                      <div v-bind:id="'collapse-exclusion-' + index" class="collapse exclusions-card">
                        <div class="card-body">
                          <button v-bind:id="'custom-block-' + item.id" v-for="item in exclusion.exclusions" v-bind:key="item.id" type="button" class="mb-1 btn btn-outline-secondary btn-block single-block custom-block">{{item.label}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </fieldset>

            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="addToCart">Add to Cart</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  name: 'products',
  data: function () {
    return {
      cart: window.localStorage.getItem('cart') ? JSON.parse(window.localStorage.getItem('cart')) : [],
      items: [],
      categories: [],
      inclusions: [],
      exclusions: [],
      category: this.$route.params.category,
      balance: this.calculateBalance()
    }
  },
  mounted: function () {
    var that = this
    var user = JSON.parse(window.localStorage.getItem('user'))
    var parentId = user.parent.id
    var merchantId = window.localStorage.getItem('merchantId')
    var period = this.$route.params.period
    // var date = this.$route.params.date

    // Now we do the highlighting for the custom options:
    $(document).off('click', '.custom-block')

    $(document).on('click', '.custom-block', function (e) {
      e.preventDefault()

      if ($(this).hasClass('single-block')) {
        $(this).parent().find('.custom-block').removeClass('active')
        $(this).addClass('active')
      } else if ($(this).hasClass('multiple-block')) {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active')
        } else {
          $(this).addClass('active')
        }
      }

      return false
    })

    var additionalParams = ''

    if (window.localStorage.getItem('boardroomId')) {
      additionalParams = '&meal_category=Meal&function=1'
    } else {
      additionalParams = '&meal_category=' + this.$route.params.category
    }

    $.ajax({
      beforeSend: function (xhr) {
        $.showLoading()
        if (window.localStorage.getItem('token')) {
          xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
        }
      },
      complete: function () {
        $.hideLoading()
      },
      url: this.$config.apiUrl + 'canteenapp_merchant/formatted_menu?parent_id=' + parentId + '&merchant_id=' + merchantId + '&period=' + period + '&date=' + this.$route.params.date + additionalParams,
      type: 'get',
      success: function (data) {
        var categories = []
        var items = []

        window.localStorage.setItem('inclusions', JSON.stringify(data.data.global_additions))
        window.localStorage.setItem('exclusions', JSON.stringify(data.data.global_exclusions))

        if (data.data.menu_items) {
          data.data.menu_items.forEach(function (category) {
            categories.push({
              title: category.meal_category,
              id: category.meal_category_id
            })

            category.menu_items.forEach(function (meal) {
              meal.meal_category_id = category.meal_category_id
              items.push(meal)
            })
          })
        }

        that.items = items
        that.categories = categories

        // Functions only has one accordion, so expand it
        if (window.localStorage.getItem('boardroomId')) {
          setTimeout(function () {
            $('.products .btn.btn-link').eq(0).trigger('click')
          }, 100)
        }
      },
      error: function (data) {
        /*
        if (data.responseJSON.message === 'Please supply a valid token.') {
          that.$router.push('/login')
        } else {
          swal({
            title: 'Error',
            text: data.responseJSON.message,
            icon: 'error',
            button: 'Ok'
          })
        }
        */
      }
    })
  },
  methods: {
    useWallet: function () {
      var output = false

      var user = JSON.parse(window.localStorage.getItem('user'))
      user.parent.company.merchants.forEach(function (merchant) {
        if (window.localStorage.getItem('merchantId') && merchant.id === window.localStorage.getItem('merchantId')) {
          if (merchant.use_wallet === 'Y') {
            output = true
          }
        }
      })

      return output
    },
    calculateBalance: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      return user.wallet_balance
    },
    showModificationsModal: function (meal) {
      window.localStorage.setItem('meal', JSON.stringify(meal))

      var inclusions = JSON.parse(window.localStorage.getItem('inclusions'))
      var exclusions = JSON.parse(window.localStorage.getItem('exclusions'))

      if (meal.additions) {
        meal.additions.forEach(function (addition) {
          inclusions.push(addition)
        })
      }

      if (meal.exclusions) {
        meal.exclusions.forEach(function (exclusion) {
          exclusions.push(exclusion)
        })
      }

      this.inclusions = inclusions
      this.exclusions = exclusions

      $('#modifications-modal').modal('show')
    },
    addToCart: function () {
      var meal = JSON.parse(window.localStorage.getItem('meal'))

      var additions = []
      var exclusions = []

      // Now we add additions and exlcusions
      if (meal.additions) {
        meal.additions.forEach(function (addition) {
          addition.additions.forEach(function (customization) {
            if ($('#custom-block-' + customization.id).hasClass('active')) {
              additions.push(customization)
            }
          })
        })
      }

      if (meal.exclusions) {
        meal.exclusions.forEach(function (exclusion) {
          exclusion.exclusions.forEach(function (customization) {
            if ($('#custom-block-' + customization.id).hasClass('active')) {
              exclusions.push(customization)
            }
          })
        })
      }

      var item = {
        mealId: meal.id,
        label: meal.label,
        price: meal.price,
        additions: additions,
        exclusions: exclusions
      }

      this.cart.push(item)
      window.localStorage.setItem('cart', JSON.stringify(this.cart))

      swal('Success', 'Item added to cart', 'success')
    },
    checkout: function () {
      if (this.cart.length === 0) {
        swal('Error', 'You need to add items to your cart first', 'error')
      } else {
        window.localStorage.setItem('cart', JSON.stringify(this.cart))
        window.localStorage.setItem('period', this.$route.params.period)
        window.localStorage.setItem('date', this.$route.params.date)

        this.$router.push('/checkout')
      }
    }
  }
}
</script>

<style scoped>
.products .btn-link {
  display:block;
  width:100%;
  text-align:left;
}
.products table {
  border:none;
  width:100%;
}
.products td {
  padding:5px;
  vertical-align:middle;
}
.additions-exclusions-form .custom-block {
  color: #6b6f80;
  border-color: #6b6f80;
  background-color: transparent;
}
.additions-exclusions-form .custom-block.active {
  color: #fff;
  border-color: #6b6f80;
  background-color: #6b6f80;
}
</style>
